import { GenericObject } from './generic-object';
import { LocalizedString } from './localized-string';
import { copyFields } from './utils';

export class Category {
    public id!: number;
    public isVisibleInShop!: boolean;
    public translations!: LocalizedString;
    public parentId?: number;
    public eclassPositions?: number[];
    public eclassLabel?: number;
    public hasChildren?: boolean;
    public path?: number[] = [];

    public static fromPlainObject(object: GenericObject): Category {
        const category = new Category();

        copyFields(object, category);
        category.translations = object['translations'] ?? object['name'];

        return category;
    }
}
